import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
 
const CustomDatePicker = (props) => {
    const [currentDate, setCurrentDate] = useState(props.value ? props.value : null);
    const [open, setOpen] = useState(false);
    
    useEffect(() => {
        setCurrentDate(props.value);
    }, [props.value]);
 
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box style={{ width: props.width }}>
                <DatePicker
                    label={props.label}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    value={currentDate ? dayjs(currentDate) : null}
                    minDate={props.minDate ? dayjs(props.minDate) : null}
                    maxDate={props.maxDate ? dayjs(props.maxDate) : null}
                    format={"MM/DD/YYYY"}
                    onChange={(newDate) => {
                        setCurrentDate(newDate);
                        props.onSelectedDate(new Date(newDate));
                    }}  
                    slotProps={{
                        textField: {
                            onKeyDown: (e) => e.preventDefault(), // Disables manual type
                            onClick: () => setOpen(true), // Open also when clicking on input
                        },
                    }}
                />
            </Box>
        </LocalizationProvider>
    )
};
 
CustomDatePicker.propTypes = {
    width: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.object,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    onSelectedDate: PropTypes.func
};
 
export default CustomDatePicker;